import { openBlock as t, createElementBlock as a, createStaticVNode as h } from "vue";
const e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, l = /* @__PURE__ */ h('<path fill="#0052B4" d="M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20c0 .005 20-20 20-20 11.046 0 20 8.954 20 20Z"></path><path fill="#F0F0F0" d="M19.947 20H20v-.053a27.01 27.01 0 0 0-.053.054ZM20 10.435V0h-.003C8.952.002 0 8.955 0 20h10.435v-5.876L16.31 20h3.636l.053-.053v-3.636l-5.876-5.876H20Z"></path><path fill="#D80027" d="M10.118 2.609a20.095 20.095 0 0 0-7.51 7.51v9.88h5.218V7.827H20V2.609h-9.882Z"></path><path fill="#D80027" d="m20 17.54-7.106-7.106h-2.46L20 19.999v-2.46Z"></path><path fill="#FFDA44" d="M34.752 15.686V10.47s-3.69-.781-6.087-.781-6.087.78-6.087.78v5.218h12.174Z"></path><path fill="#338AF3" d="M22.578 15.625v4.832c0 4.315 6.094 5.637 6.094 5.637s6.094-1.322 6.094-5.637v-4.832H22.578Z"></path><path fill="#000" d="M28.711 14.219a1.523 1.523 0 1 0 0-3.047 1.523 1.523 0 0 0 0 3.047Z"></path>', 7), n = [
  l
];
function o(i, p) {
  return t(), a("svg", e, [...n]);
}
const s = { render: o };
export {
  s as default,
  o as render
};
